module.exports = __webpack_public_path__ + "static/media/RP-82.816cd97a.pdf";